export default function SearchIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.33366 15C4.65176 15 1.66699 12.0152 1.66699 8.33332C1.66699 4.65142 4.65176 1.66666 8.33366 1.66666C12.0156 1.66666 15.0003 4.65142 15.0003 8.33332C15.0003 9.87391 14.4778 11.2925 13.6002 12.4214L18.0896 16.9107L16.9111 18.0892L12.4217 13.5999C11.2928 14.4774 9.87425 15 8.33366 15ZM8.33366 13.3333C11.0951 13.3333 13.3337 11.0947 13.3337 8.33332C13.3337 5.5719 11.0951 3.33332 8.33366 3.33332C5.57223 3.33332 3.33366 5.5719 3.33366 8.33332C3.33366 11.0947 5.57223 13.3333 8.33366 13.3333Z"
        fill="currentColor"
      />
    </svg>
  )
}
